/** @jsxImportSource @emotion/react */
import { useId, useState } from "react";
import { useParams } from "react-router-dom";
import PhaseRulesTable from "tables/PhaseRulesTable";
import { TableIdProvider } from "context/tableId";
import useGetPhaseRulesQuery from "hookQueries/useGetPhaseRulesQuery";
import RuleFormModal from "./RuleFormModal";
import Layout from "./Layout";

export default function PhaseRules() {
  const { id: campaignId } = useParams();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedRule, setSelectedRule] = useState(null);
  const tableId = useId();

  const { data: rules, isLoading } = useGetPhaseRulesQuery(campaignId);

  const handleNewRule = () => {
    setSelectedRule(null);
    setIsModalOpen(true);
  };

  const handleEditRule = (rule) => {
    setSelectedRule(rule);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedRule(null);
  };

  return (
    <Layout handleNewRule={handleNewRule}>
      <div>
        <TableIdProvider value={{ tableId }}>
          <PhaseRulesTable rules={rules} isLoading={isLoading} onEdit={handleEditRule} />
        </TableIdProvider>

        {isModalOpen && (
          <RuleFormModal
            isOpen={isModalOpen}
            onClose={handleCloseModal}
            rule={selectedRule}
            campaignId={parseInt(campaignId, 10)}
          />
        )}
      </div>
    </Layout>
  );
}
